import { useAppConfig } from '../hooks/useAppConfig';
import { AuthApi as CoreAuthApi } from '@mc/react-auth';
import { baseAxios } from '@mc/axios-api';
import * as Api from './gen/api';

const appConfig = useAppConfig();

const AuthApi = new CoreAuthApi(
  { baseURL: appConfig.serverContextPath },
  baseAxios
);

const baseURL = '';
const GlobalSettingsApi = new Api.GlobalSettingsControllerApi(undefined, baseURL, baseAxios);
export {AuthApi, GlobalSettingsApi, Api};